var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bidding-room mt-20"},[_c('block-head',{attrs:{"title":"竞价大厅","hid-more-btn":"","icon":"bidding"}}),_c('div',{staticStyle:{"height":"462px","overflow":"hidden"}},[_c('iframe',{staticClass:"bidding-room-body mt-20",attrs:{"src":_vm.link,"frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }